
    import '/opt/buildhome/repo/docs/playground/independent.zh-CN.md?watch=parent';
    export const toc = [];
export const frontmatter = {"title":"独立式","toc":"menu","filename":"docs/playground/independent.zh-CN.md","lastUpdated":1732259528000,"group":{"title":"样板间","order":0},"__autoDescription":true};